import React, { useState, useEffect } from "react";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useParams } from "react-router-dom";
import { Row, Col, Skeleton, Image, Button, Modal, Divider } from "antd";
import { apiUrl } from "@utils/apoloClient";
import StrikethroughPrice from "@general/strikethroughPrice";
import { useNavigate } from "react-router-dom";
import SafeHtml from "@general/safeHtml";

const ClassesSingle = () => {
  const [classDetails, setClassDetails] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  const GETPRODUCT = gql`
    query ($id: ID!) {
      getProduct(id: $id) {
        name
        description
        strikethroughRial
        amountRial
        capacity
        image
      }
    }
  `;
  const [getClassData, classData] = useLazyQuery(GETPRODUCT, {
    fetchPolicy: "no-cache",
    onCompleted({ getProduct }) {
      setClassDetails(getProduct);
    },
    onError(err) {
      console.log("Error while fetching product: ", err.message);
    },
  });

  const REQUESTCLASS = gql`
    mutation ($productId: ID!) {
      createClassInvoice(productId: $productId) {
        id
      }
    }
  `;
  const [runRequestClass, requestClass] = useMutation(REQUESTCLASS, {
    onError(err) {
      Modal.error({
        title: err.message,
        okText: "باشه",
      });
    },
    onCompleted({ createClassInvoice }) {
      navigate(`/invoice/${createClassInvoice.id}`);
    },
  });

  const createInvoice = () => {
    runRequestClass({
      variables: {
        productId: id,
      },
    });
  };
  useEffect(() => {
    getClassData({ variables: { id } });
  }, []);
  if (classData.loading) {
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  }
  const { name, description, strikethroughRial, amountRial, capacity, image } =
    classDetails;
  return (
    <>
      <Row gutter={30} align={"middle"} style={{direction: "ltr"}} justify="center">
        
        <Col lg={8} md={10}>
          <Image width={"auto"} src={image ? apiUrl + image : "error"} className="single-event-img"/>
        </Col>
        <Col lg={16} md={14} style={{direction: "rtl"}}>
          <h2 style={{ fontWeight: 600, marginBottom: 30 }}>{name}</h2>
          {description ? (
            <SafeHtml
              content={description}
              className="service-description-content"
            />
          ) : (
            <p>{`${name} به میزبانی مجموعه صفاتک`}</p>
          )}
        </Col>
      </Row>
      <Divider orientation="right">مشخصات دوره‌های آموزشی</Divider>

      <Row style={{ marginTop: 30 }}>
        <Col lg={16} md={24} xs={24}>
          <Row>
            <Col sm={12} xs={24} style={{ border: "1px solid  #f2f2f2", padding: 15 }}>
              <h4 className="text-bold">هزینه ثبت نام:</h4>
              <StrikethroughPrice
                strikethroughRial={strikethroughRial}
                amountRial={amountRial}
              />
            </Col>
            <Col sm={12} xs={24} style={{ border: "1px solid  #f2f2f2", padding: 15 }}>
              <h4 className="text-bold" style={{ display: "block" }}>
                ظرفیت:
              </h4>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <p
                  className="text-bold"
                  style={{ textAlign: "center", margin: "0 5px" }}
                >
                  {capacity}
                </p>
                <p> {"نفر"}</p>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: 30 }}>
            <Button
              style={{ width: 150,margin: "auto", marginTop: 30}}
              type="primary"
              onClick={createInvoice}
            >
              ثبت نام
            </Button>
          </Row>
        </Col>
        <Col lg={8} ></Col>
      </Row>
    </>
  );
};

export default ClassesSingle;
